<section class="space-y-8 px-4 md:mx-auto md:max-w-screen-lg md:p-8">
    <h2 class="pb-0 text-4xl md:mb-16 md:text-5xl">FAQs</h2>
    <div class="pb-4">
        <app-faq-contentful-list [faqs]="faqs"></app-faq-contentful-list>
    </div>
</section>
